import { useProposalState, useAuthState } from '@src/shared/hooks';
import { Breadcrumb } from '@src/shared/ui';
import React from 'react';

export const BreadcrumbFaq: React.FC = () => {
  const { proposal } = useProposalState();
  const { token } = useAuthState();

  const urlHome = proposal?.proposalId
    ? `/${proposal?.proposalId || ''}/proposal/${token || ''}`
    : '/error';

  return (
    <Breadcrumb
      className={`
              mt-8
              row-start-1
              col-start-1
              col-span-8
              hidden
              sm:block
              md:col-span-12
              `}
      tree={[
        {
          name: 'Planos e Parcelas',
          url: urlHome,
        },
        {
          name: 'Como funciona o Boleto Parcelado PaGol',
          url: '/',
        },
      ]}
    />
  );
};
